import React from 'react'

type Props = {
    className?: string
}


export default function QuickSearch_StartScreen(props: Props) {
    return (
        <div className="main ui5-bg-gray">

            <div className="blocks">
                <div className="flex-row-center-center ui5-txt-no-accent-default w-100p m-t-50">
                    Search by task title, task ID, project, user or application module name.
                </div>
            </div>

            <div className="keyboard-shortcut">
                <div className="icon i5-keyboard"/>
                <div className="shortcut-button">G</div>
            </div>

        </div>
    )

}
